import { TextField, Select, Box, styled, Card } from "@mui/material";

export const StyledCard = styled(Card)({
  width: "auto",
  margin: 20,
  padding: 10,
  border:"2px solid #F7F7F7" ,
  boxShadow: 10,
  cursor: "pointer",
  "&:hover": {
    background: "#F7F7F7",
  },
});
